import { Component, OnInit } from '@angular/core';
import { trigger, transition, query, style, animate } from '@angular/animations';
@Component({
  selector: 'app-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss'],
  animations: [
    trigger('routeAnimation', [
      transition('* => *', [
        query(
          ':enter',
          style({
            opacity: 0,
            margin: 0,
            transform: 'scale(.8)'
          }),
          { optional: true }
        ),
        query(
          ':enter',
          animate(
            '200ms ease-in',
            style({
              opacity: 1,
              transform: 'scale(1)'
            })
          ),
          { optional: true }
        )
      ])
    ])
  ]
})
export class RoleManagementComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
